/**
 * components/clients/PendingMatchBanner.tsx
 *
 * Discreet banner shown on the Clients page when one or more completed form submissions
 * have a pending client match status that requires pro intervention.
 * Clicking it opens the ClientMatchResolverModal.
 * Created Apr 2026.
 */

import { UserCheck, ChevronRight } from 'lucide-react';

interface PendingMatchBannerProps {
  count: number;
  onClick: () => void;
}

export default function PendingMatchBanner({ count, onClick }: PendingMatchBannerProps) {
  if (count === 0) return null;

  return (
    <button
      onClick={onClick}
      className="w-full flex items-center justify-between gap-3 px-4 py-3 bg-primary-50 border border-primary-200 rounded-xl text-left hover:bg-primary-100 transition-colors group"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
          <UserCheck className="w-4 h-4 text-primary-600" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-medium text-primary-800">
            {count === 1
              ? '1 formulaire à rattacher à un client'
              : `${count} formulaires à rattacher à un client`}
          </p>
          <p className="text-xs text-primary-600">
            Cliquez pour identifier et rattacher les réponses
          </p>
        </div>
      </div>
      <ChevronRight className="w-4 h-4 text-primary-500 flex-shrink-0 group-hover:translate-x-0.5 transition-transform" />
    </button>
  );
}
